import configure from "configure"
import moment from "moment"
import React from "react"
import { Link } from "react-router-dom"
import ZithasLogo from "../../../assets/images/main-zithas.png"
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"
import { Tooltip } from "antd"
import { getInitials } from "utils/common-helpers"

export const staffColumns = (
  statusChange,
  onViewModal,
  onEditPermission,
  onClearLogin,
  onDeletePermission,
  openAppointmentModal
) => [
    {
      Header: "Emp Id ",
      accessor: "employee_code",
      isInfoIcon: false,
      isShortIcon: true,
      className: "employee_code",
      Cell: cellProps => {
        return (
          <span>
            {cellProps.row.original.employee_code || "--"}
          </span>
        )
      },
    },
    {
      Header: "Name",
      accessor: "name",
      isInfoIcon: true,
      isShortIcon: true,
      className: "employee_name",
      Cell: cellProps => {
        const row = cellProps.row.original

        // Determine avatar URL
        const rawAvatar = row?.avatar || row?.assignee_avatar || row?.staff_avatar
        const avatar =
          rawAvatar && rawAvatar !== "null"
            ? `${configure.imgUrl}${rawAvatar}`
            : null

        // Get display name
        const name = row?.alias_name || row?.name || ""

        // Tooltip text
        const tooltip = row?.staff_name || row?.alias_name || row?.assignee || ""

        return (
          <div className="d-flex align-items-center gap-2">
            {avatar ? (
              <img
                src={avatar}
                alt="Avatar"
                title={tooltip} // tooltip for hover
                className="img-fluid rounded-circle"
                width={22}
                height={22}
                onError={e => {
                  e.target.onerror = null
                  e.target.src = ZithasLogo // fallback image
                }}
              />
            ) : (
              <div
                className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
                title={tooltip}
                style={{ width: 22, height: 22, fontSize: 10 }}
              >
                {getInitials(tooltip || name)}
              </div>
            )}

            <span className="text-truncate" style={{ maxWidth: 120 }}>
              {name}
            </span>
          </div>
        )
      },
    },
    {
      Header: "Designation",
      accessor: "designation",
      isInfoIcon: true,
      isShortIcon: true,
      className: "employee_designation",
      Cell: cellProps => {
        return (
          <span>
            {cellProps.row.original.designation || "--"}
          </span>
        )
      },
    },
    {
      Header: "Phone no",
      accessor: "phone_number",
      isInfoIcon: true,
      isShortIcon: true,
      className: "employee_phone",
    },
    {
      Header: "Email Id",
      accessor: "email",
      isInfoIcon: true,
      isShortIcon: true,
      className: "employee_email",
      Cell: cellProps => {
        return (
          <span>
            {cellProps.row.original.email || cellProps.row.original.personal_email}
          </span>
        )
      },
    },
    {
      Header: "Joining Date",
      accessor: "date_of_joining",
      isInfoIcon: false,
      isShortIcon: true,
      className: "employee_date_of_joining ",
      Cell: cellProps => {
        return (
          <div className="text-center" >
            {
              cellProps.row.original.date_of_joining ?
                moment(cellProps.row.original.date_of_joining).format("DD-MM-YYYY") : <span className="badge bg-info">New Joiner</span>}
          </div>
        )
      },
    },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   className: "employee_status text-center",
    //   Cell: cellProps => {
    //     return (
    //       <div className="form-switch form-switch-md">
    //         <input
    //           type="checkbox"
    //           className="form-check-input"
    //           id="customSwitchsizemd"
    //           defaultChecked={cellProps.row.original.login_access == "1"}
    //           onChange={e =>
    //             statusChange(
    //               e,
    //               cellProps.row.original.id,
    //               e.target.checked ? 1 : 0
    //             )
    //           }
    //         />
    //       </div>
    //     )
    //   },
    //   isInfoIcon: true,
    // },
    {
      Header: "Status",
      accessor: "status",
      className: "employee_status text-center",
      Cell: cellProps => {
        return (
          <div className="form-switch form-switch-md">
            <input
              type="checkbox"
              className="form-check-input"
              id="customSwitchsizemd"
              checked={cellProps.row.original.login_access == "1"}
              disabled={cellProps.row.original.approve_status == 0 || cellProps.row.original.approve_status == 2}
              onClick={e => {
                const newValue = cellProps.row.original.login_access == "1" ? 0 : 1
                const oldValue = cellProps.row.original.login_access

                statusChange(
                  e,
                  cellProps.row.original.id,
                  newValue,
                  cellProps?.row?.original
                )

                // if (oldValue == 1 && newValue == 0) {
                //   onDisable(cellProps.row.original.id)
                // }
              }}
            />
          </div>
        )
      },
      isInfoIcon: true,
    },
    {
      Header: "Action",
      accessor: "action",
      className: "employee_action",
      Cell: cellProps => {
        return (
          <div className="d-flex justify-content-center">
            <a
              className="btn btn-sm action-btn btn-outline-secondary me-1"
              onClick={() => {
                onViewModal(true, cellProps.row.original.id)
              }}
            >
              <i className="fas fa-eye"></i>
            </a>
            <Link
              onClick={() =>
                onEditPermission({
                  id: cellProps.row.original.id,
                  isEditType: 1,
                })
              }
              className="btn action-btn btn-sm me-1 btn-outline-secondary"
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            <UncontrolledDropdown className="dropdown" style={{ width: "29px" }}>
              <DropdownToggle
                className="btn btn-sm btn-outline-secondary w-100"
                color="white"
              >
                <i className="mdi mdi-dots-horizontal"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                {
                  cellProps.row.original.approve_status == 1 &&
                  <a
                    onClick={() => onClearLogin({ id: cellProps.row.original.id })}
                    className="dropdown-item"
                    title="Clear Login"
                  >
                    <i className="fa fa-history pr-10"></i> Clear Login
                  </a>
                }
                {/* {
                  cellProps.row.original.approve_status == 1 &&
                  <a
                    onClick={() => openAppointmentModal(cellProps.row.original)}
                    className="dropdown-item"
                    title="Appointment Letter"
                  >
                    <i className="fa fa-book pr-10"></i> Appointment Letter
                  </a>
                } */}

                <a
                  onClick={() =>
                    onDeletePermission({ id: cellProps.row.original.id })
                  }
                  className="dropdown-item"
                  title="delete"
                >
                  <i className="fas fa-trash-alt pr-10 text-danger"></i> Delete
                  Staff
                </a>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )
      },
    },
  ]

export const allEmployeesColumns = (onViewModal, onDeletePermission) => [
  {
    Header: "Emp Id ",
    accessor: "employee_code",
    isInfoIcon: false,
    isShortIcon: true,
    className: "employee_code",
  },
  {
    Header: "Name",
    accessor: "name",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_name",
    Cell: cellProps => {
      const row = cellProps.row.original

      // Determine avatar URL
      const rawAvatar = row?.avatar || row?.assignee_avatar || row?.staff_avatar
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null

      // Get display name
      const name = row?.alias_name || row?.name || ""

      // Tooltip text
      const tooltip = row?.staff_name || row?.alias_name || row?.assignee || ""

      return (
        <div className="d-flex align-items-center gap-2">
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              title={tooltip} // tooltip for hover
              className="img-fluid rounded-circle"
              width={22}
              height={22}
              onError={e => {
                e.target.onerror = null
                e.target.src = ZithasLogo // fallback image
              }}
            />
          ) : (
            <div
              className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
              title={tooltip}
              style={{ width: 22, height: 22, fontSize: 10 }}
            >
              {getInitials(tooltip)}
            </div>
          )}

          <span className="text-truncate" style={{ maxWidth: 120 }}>
            {name}
          </span>
        </div>
      )
    },
  },
  {
    Header: "Designation",
    accessor: "designation",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_designation",
  },
  {
    Header: "Phone no",
    accessor: "phone_number",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_phone",
  },
  {
    Header: "Email Id",
    accessor: "email",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_email",
  },
  {
    Header: "Joining Date",
    accessor: "date_of_joining",
    isInfoIcon: false,
    isShortIcon: true,
    className: "employee_date_of_joining",
    Cell: cellProps => {
      return (
        <span>
          {moment(cellProps.row.original.date_of_joining).format("DD-MM-YYYY")}
        </span>
      )
    },
  },
  {
    Header: "Total Time",
    accessor: "total_days",
    isInfoIcon: false,
    isShortIcon: true,
    className: "employee_total_days",
    Cell: cellProps => {
      const joiningDate = cellProps.row.original.date_of_joining

      if (!joiningDate) return <span>-</span>

      const start = moment(joiningDate)
      const end = moment()

      if (!start.isValid()) return <span>-</span>

      const duration = moment.duration(end.diff(start))

      const years = duration.years()
      const months = duration.months()
      const days = duration.days()

      return (
        <span>
          {years} y {months} m {days} d
        </span>
      )
    },
  },

  {
    Header: "Action",
    accessor: "action",
    className: "employee_action text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            href={`https://edemo.zithas.com/edit-staff/${cellProps.row.original.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm action-btn btn-outline-secondary me-1"
          >
            <i className="fas fa-eye"></i>
          </a>
        </div>
      )
    },
  },
]

export const SwipeColumns = (onEditOpen, onInfoOpen, onDeletSwipe) => [
  // {
  //   Header: "Staff",
  //   accessor: "id",
  //   isInfoIcon: false,
  //   className: "swipe_id",
  //   isShortIcon: true,
  //   Cell: cellProps => {
  //     return (
  //       <img src={`${cellProps?.row?.original?.avatar != null ? `${configure.imgUrl}/${cellProps?.row?.original?.avatar}` : `${ZithasLogo}`}`} alt="user Image" className="img-fluid cursor-pointer me-2" title={cellProps?.row?.original?.name} style={{ width: "30px", borderRadius: "100%" }} />
  //     )
  //   }
  // },
  {
    Header: "Staff",
    accessor: "id",
    isInfoIcon: false,
    className: "swipe_id text-center",
    isShortIcon: true,
    Cell: cellProps => {
      const data = cellProps?.row?.original

      return (
        <div className="d-flex justify-content-center w-100">
          {data?.avatar ? (
            <img
              src={`${cellProps?.row?.original?.avatar != null
                ? `${configure.imgUrl}/${cellProps?.row?.original?.avatar}`
                : `${ZithasLogo}`
                }`}
              alt="user Image"
              className="img-fluid cursor-pointer me-2"
              title={cellProps?.row?.original?.name}
              style={{ width: "30px", borderRadius: "100%" }}
            />
          ) : (
            <div className="defualt-img" title={cellProps?.row?.original?.name}>
              {getInitials(data?.name || "Z")}
            </div>
          )}
        </div>
      )
    },
  },
  {
    Header: "Swipes",
    accessor: "reason",
    grow: false,
    className: "swipe_name",
    isShortIcon: true,
  },
  {
    Header: "Status",
    accessor: "status",
    grow: false,
    className: "swipe_status",
    Cell: cellProps => {
      const swipeStatus = cellProps.row?.original.status
      let badge
      if (swipeStatus == 0) {
        badge = <span className="badge bg-warning fs-14">Pending</span>
      } else if (swipeStatus == 1) {
        badge = <span className="badge bg-success fs-14">Approved</span>
      } else if (swipeStatus == 2) {
        badge = <span className="badge bg-danger fs-14">Rejected</span>
      }
      return <div>{badge}</div>
    },
  },
  {
    Header: "Applied Date",
    accessor: "date",
    grow: false,
    className: "swipe_date text-center",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>{moment(cellProps?.row?.original?.date).format("DD-MM-YYYY")}</div>
      )
    },
  },
  {
    Header: "Action",
    accessor: "swipe_action",
    className: "text-center swipe_action",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-sm me-1 btn-outline-secondary"
            title="Edit Swipe"
            onClick={() => onEditOpen(cellProps.row.original)}
          >
            <i className="fa fa-pencil-alt"></i>
          </button>
          <button
            className="btn btn-sm me-1 btn-outline-secondary"
            title="Delete Swipe"
            onClick={() => onDeletSwipe(cellProps.row.original?.id)}
          >
            <i className="fa fa-trash-alt text-danger"></i>
          </button>
          {cellProps?.row?.original?.status == 2 ? (
            <button
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Info"
              onClick={() => onInfoOpen(cellProps.row.original?.reason)}
            >
              <i className="fa fa-info"></i>
            </button>
          ) : cellProps?.row?.original?.status == 1 ? (
            <Tooltip
              color={"#752b97"}
              title={`Approve for ${cellProps?.row?.original?.amount} days`}
            >
              <button
                className="btn btn-sm me-1 btn-outline-secondary"
                title="Info"
              >
                <i className="fa fa-info"></i>
              </button>
            </Tooltip>
          ) : null}
        </div>
      )
    },
  },
]

export const IssuesColumns = (onEditOpen, onDeletIssue, onOpenUnapprove) => [
  // {
  //   Header: "Staff",
  //   accessor: "id",
  //   isInfoIcon: false,
  //   className: "issues_id",
  //   isShortIcon: true,
  //   Cell: cellProps => {
  //     return (
  //       <img
  //         src={`${
  //           cellProps?.row?.original?.avatar != null
  //             ? `${configure.imgUrl}/${cellProps?.row?.original?.avatar}`
  //             : `${ZithasLogo}`
  //         }`}
  //         alt="user Image"
  //         className="img-fluid cursor-pointer me-2"
  //         title={cellProps?.row?.original?.name}
  //         style={{ width: "30px", borderRadius: "100%" }}
  //       />
  //     )
  //   },
  // },
  {
    Header: "Staff",
    accessor: "id",
    isInfoIcon: false,
    className: "swipe_id text-center",
    isShortIcon: true,
    Cell: cellProps => {
      const data = cellProps?.row?.original

      return (
        <div className="d-flex justify-content-center w-100">
          {data?.avatar ? (
            <img
              src={`${cellProps?.row?.original?.avatar != null
                ? `${configure.imgUrl}/${cellProps?.row?.original?.avatar}`
                : `${ZithasLogo}`
                }`}
              alt="user Image"
              className="img-fluid cursor-pointer me-2"
              title={cellProps?.row?.original?.name}
              style={{ width: "30px", borderRadius: "100%" }}
            />
          ) : (
            <div className="defualt-img" title={cellProps?.row?.original?.name}>
              {getInitials(data?.name || "Z")}
            </div>
          )}
        </div>
      )
    },
  },
  {
    Header: "Issues",
    accessor: "reason",
    grow: false,
    className: "issues_name",
    isShortIcon: true,
  },
  {
    Header: "Status",
    accessor: "status",
    grow: false,
    className: "issues_status",
    Cell: cellProps => {
      const swipeStatus = cellProps.row?.original.status
      let badge
      if (swipeStatus == 0) {
        badge = <span className="badge bg-warning fs-14">Pending</span>
      } else if (swipeStatus == 1) {
        badge = <span className="badge bg-success fs-14">Approved</span>
      } else if (swipeStatus == 2) {
        badge = <span className="badge bg-danger fs-14">Rejected</span>
      }
      return <div>{badge}</div>
    },
  },

  {
    Header: "Action",
    accessor: "issues_action",
    className: "text-center issues_action",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-start">
          <button
            className="btn btn-sm me-1 btn-outline-secondary"
            title="Edit Issue"
            onClick={() => onEditOpen(cellProps.row?.original)}
          >
            <i className="fa fa-pencil-alt"></i>
          </button>

          <button
            className="btn btn-sm me-1 btn-outline-secondary"
            title="Delete Issue"
            onClick={() => onDeletIssue(cellProps.row?.original?.id)}
          >
            <i className="fa fa-trash-alt text-danger"></i>
          </button>
          {cellProps?.row?.original?.status != 0 ? (
            <button
              className="btn btn-sm me-1 btn-outline-secondary"
              title="Info"
              onClick={() =>
                onOpenUnapprove(
                  cellProps.row?.original?.status,
                  cellProps.row?.original?.final_decision,
                  cellProps.row?.original?.approve_reason
                )
              }
            >
              <i className="fa fa-info"></i>
            </button>
          ) : null}
        </div>
      )
    },
  },
]

export const punchApprovalColumns = onApprove => [
  {
    Header: "ID",
    accessor: "id",
    className: "db_swipe_id",
    isShortIcon: true,
  },
  {
    Header: "Staff",
    accessor: "name",
    className: "col-2",
    isShortIcon: true,
    Cell: cellProps => {
      const name = cellProps?.row?.original
      return (
        <div className="d-flex justify-content-start gap-1 align-items-center">
          <img
            className="img-fluid cursor-pointer me-2 rounded-circle"
            width={22}
            height={22}
            src={`${configure.imgUrl}/${name?.avatar}`}
            alt="Image"
          />{" "}
          {name?.alias_name}
        </div>
      )
    },
  },
  {
    Header: "Reason",
    accessor: "reason",
    className: "col-5",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.reason} -{" "}
          {cellProps?.row?.original?.description}
        </div>
      )
    },
  },
  {
    Header: "Date",
    accessor: "punch_date",
    className: "",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original?.punch_date).format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Start Time",
    accessor: "startTime",
    className: "",
    isShortIcon: true,
  },
  {
    Header: "End Time",
    accessor: "endTime",
    className: "",
    isShortIcon: true,
  },
  {
    Header: "Action",
    accessor: "db_swipe_actions text-center",
    className: "db_swipe_actionss text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          <a
            className="btn btn-sm btn-outline-primary me-1"
            title="Approve"
            onClick={() => onApprove(1, cellProps?.row?.original?.id)}
          >
            <i className="bi bi-check-lg icon-center"></i>
          </a>
          <a
            className="btn btn-sm btn-outline-danger me-1"
            title="Disapprove"
            onClick={() => onApprove(2, cellProps?.row?.original?.id)}
          >
            <i className="dripicons-cross icon-center"></i>
          </a>
        </div>
      )
    },
  },
]

export const myPunchApprovalColumns = (onAction, onView) => [
  {
    Header: "ID",
    accessor: "id",
    className: "db_swipe_id",
    isShortIcon: true,
  },
  {
    Header: "Staff",
    accessor: "name",
    className: "col-2",
    isShortIcon: true,
    Cell: cellProps => {
      const name = cellProps?.row?.original
      return (
        <div className="d-flex justify-content-start gap-1 align-items-center">
          <img
            className="img-fluid cursor-pointer me-2 rounded-circle"
            width={22}
            height={22}
            src={`${configure.imgUrl}/${name?.avatar}`}
            alt="Image"
          />{" "}
          {name?.alias_name}
        </div>
      )
    },
  },
  {
    Header: "Reason",
    accessor: "reason",
    className: "col-5",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {cellProps?.row?.original?.reason} -{" "}
          {cellProps?.row?.original?.description}
        </div>
      )
    },
  },
  {
    Header: "Date",
    accessor: "punch_date",
    className: "",
    isShortIcon: true,
    Cell: cellProps => {
      return (
        <div>
          {moment(cellProps?.row?.original?.punch_date).format("DD-MM-YYYY")}
        </div>
      )
    },
  },
  {
    Header: "Start Time",
    accessor: "startTime",
    className: "",
    isShortIcon: true,
  },
  {
    Header: "End Time",
    accessor: "endTime",
    className: "",
    isShortIcon: true,
  },
  {
    Header: "Action",
    accessor: "db_swipe_actions text-center",
    className: "db_swipe_actionss text-center",
    Cell: cellProps => {
      return (
        <div className="d-flex justify-content-center">
          {cellProps?.row?.original?.status != 2 ? (
            <>
              <button
                title="edit"
                className="btn btn-sm btn-outline-secondary me-1"
                onClick={() => onAction(0, cellProps?.row?.original)}
                disabled={cellProps?.row?.original?.status == 1}
              >
                <i className="fas fa-pen "></i>
              </button>
              <button
                className="btn btn-sm me-1 btn-outline-danger"
                title="Trash Lead"
                onClick={() => onAction(1, cellProps?.row?.original)}
                disabled={cellProps?.row?.original?.status == 1}
              >
                <i className="bi bi-trash"></i>
              </button>
            </>
          ) : (
            <button
              title="View"
              className="btn btn-sm btn-outline-secondary me-1"
              onClick={() => onView(cellProps?.row?.original?.rej_description)}
            >
              <i className="fas fa-eye "></i>
            </button>
          )}
        </div>
      )
    },
  },
]

export const inactiveStaffColumns = onStatusToggle => [
  {
    Header: "Emp Id ",
    accessor: "employee_code",
    isInfoIcon: false,
    isShortIcon: true,
    className: "employee_code",
  },
  {
    Header: "Name",
    accessor: "name",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_name",
    Cell: cellProps => {
      const row = cellProps.row.original

      // Determine avatar URL
      const rawAvatar = row?.avatar || row?.assignee_avatar || row?.staff_avatar
      const avatar =
        rawAvatar && rawAvatar !== "null"
          ? `${configure.imgUrl}${rawAvatar}`
          : null

      // Get display name
      const name = row?.alias_name || row?.name || ""

      // Tooltip text
      const tooltip = row?.staff_name || row?.alias_name || row?.assignee || ""

      return (
        <div className="d-flex align-items-center gap-2">
          {avatar ? (
            <img
              src={avatar}
              alt="Avatar"
              title={tooltip} // tooltip for hover
              className="img-fluid rounded-circle"
              width={22}
              height={22}
              onError={e => {
                e.target.onerror = null
                e.target.src = ZithasLogo // fallback image
              }}
            />
          ) : (
            <div
              className="defualt-img rounded-circle d-flex align-items-center justify-content-center"
              title={tooltip}
              style={{ width: 22, height: 22, fontSize: 10 }}
            >
              {getInitials(tooltip)}
            </div>
          )}

          <span className="text-truncate" style={{ maxWidth: 120 }}>
            {name}
          </span>
        </div>
      )
    },
  },
  {
    Header: "Designation",
    accessor: "designation",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_designation",
  },
  {
    Header: "Phone no",
    accessor: "phone_number",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_phone",
  },
  {
    Header: "Email Id",
    accessor: "email",
    isInfoIcon: true,
    isShortIcon: true,
    className: "employee_email",
  },
  {
    Header: "Inactive Days",
    accessor: "days_inactive",
    isInfoIcon: false,
    isShortIcon: true,
    className: "employee_date_of_joining",
  },
  {
    Header: "Status",
    accessor: "login_access",
    className: "employee_status text-center",
    Cell: cellProps => {
      return (
        <div className="form-switch form-switch-md">
          <input
            type="checkbox"
            className="form-check-input"
            checked={cellProps.row.original.login_access == 1}
            onChange={e =>
              onStatusToggle(cellProps.row.original, e.target.checked)
            }
          />
        </div>
      )
    },
    isInfoIcon: true,
  },
]
